<script setup lang="ts">
import {
  AccordionRoot,
  AccordionRootEmits,
  AccordionRootProps,
  useForwardPropsEmits,
} from 'radix-vue'

const props =
  defineProps<AccordionRootProps<string | string[], 'single' | 'multiple'>>()
const emits = defineEmits<AccordionRootEmits<'single' | 'multiple'>>()
const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
  <AccordionRoot v-bind="forwarded">
    <slot></slot>
  </AccordionRoot>
</template>
